var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("mds-combo-box", {
    attrs: {
      label: _vm.translate("scheduler.modal.performanceReport.label"),
      "data-set": _vm.performanceReportOptions,
      "selected-items": _vm.option,
      disabled:
        !!_vm.queriedPerformanceReportId ||
        !_vm.performanceReportOptions.length,
      error: !_vm.performanceReportOptions.length,
      errorText: [_vm.translate("scheduler.modal.performanceReport.error")],
    },
    on: { input: _vm.onChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }